import React from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { ChartTooltip } from "./chartTheme";

const tick = { fontSize: 11, fill: "hsl(150, 10%, 46%)", fontFamily: "Segoe UI Regular, sans-serif, system-ui" };

const WeekdayBarChart = ({ data = [], dataKey, name, color }) => (
  <ResponsiveContainer width="100%" height="100%">
    <BarChart data={data} margin={{ top: 8, right: 12, bottom: 0, left: -12 }}>
      <CartesianGrid strokeDasharray="3 3" stroke="hsl(140, 8%, 90%)" vertical={false} />
      <XAxis dataKey="day" tick={tick} axisLine={{ stroke: "hsl(140, 8%, 88%)" }} tickLine={false} />
      <YAxis tick={tick} axisLine={false} tickLine={false} allowDecimals={false} width={28} />
      <Tooltip content={<ChartTooltip />} cursor={{ fill: "hsl(140, 8%, 95%)" }} />
      <Bar dataKey={dataKey} name={name} fill={color} radius={[4, 4, 0, 0]} maxBarSize={40} />
    </BarChart>
  </ResponsiveContainer>
);

export default WeekdayBarChart;
